import { render, staticRenderFns } from "./BootstrapCollapse.vue?vue&type=template&id=08e905a6"
import script from "./BootstrapCollapse.vue?vue&type=script&lang=js"
export * from "./BootstrapCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports